import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form'
import { Button } from 'reactstrap';
import { renderField, validate } from '../../helpers/validation.helper';

class ChangePasswordForm extends Component {
    
    render(){
        const { handleSubmit } = this.props;
        return (
            <div>
                <div className="edit-user-details-page">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="col-lg-12">
                                <div className="edit-profile-item-header">
                                    <span className="profile-favorite">Schimbă parola!</span>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <Field
                                                id="oldPassword"
                                                name="oldPassword"
                                                type="password"
                                                placeholder="Parola veche"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            &nbsp;
                                        </div>
                                        <div className="col-lg-6">
                                            <Field
                                                id="password"
                                                name="password"
                                                type="password"
                                                placeholder="Noua parolă"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            &nbsp;
                                        </div>
                                        <div className="col-lg-6">
                                            <Field
                                                id="passwordConfirm"
                                                name="passwordConfirm"
                                                type="password"
                                                placeholder="Confirmă parola"
                                                component={renderField}
                                            />
                                        </div>
                                        <div className="col-lg-6">
                                            &nbsp;
                                        </div>
                                    </div>
                                    <div className="col-lg-12 clearfix ">
                                        <Button className="btn-cinemap-blue register-user float-right" type="submit">Salvează</Button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default reduxForm({
    form: 'changePasswordForm',
    validate: validate('changePasswordForm')
})(ChangePasswordForm)
    



// WEBPACK FOOTER //
// ./src/SHARED/components/editUserDetails/changePasswordForm.js